import ContentCard from '../../components/TrackCard/ContentCard';
import { useCallback, useMemo } from 'react';
import UsageTracker from '../../utils/UsageTracker';
import { useTrack } from '../../features/tracks';
// @ts-expect-error Could not find a declaration file for module
import useFilterParams from '../../hooks/useFilterParams';
import enviro from 'enviro';
import { getListingUrl } from '../../utils/RoutingUtils';
import { useLocation } from 'react-router-dom';
import { FILTER_CONSTS, FILTER_TYPES } from '../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParamInput } from '../../hooks/searchParamHooks';
import TrackThumbnailOverlayed from '../../components/TrackCard/Thumbnail/TrackThumbnailOverlayed';
// @ts-expect-error Could not find a declaration file for module
import TrackDeprecatedDescription from '../../components/TrackCard/TrackDeprecatedDescription';
import { useAssetStatus } from '../../features/userProgress';
import { TrackCategoryInfoButton } from '../../features/categories';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const TrackCardContainer = ({
  trackId,
  isFlushOnMobile = true,
  isUnfilterable,
  position,
  appearsIn,
  isGhost,
  onClick,
  footer,
  thumbnailHeaderIcons,
  preferPreviewModal,
  language: forceLanguage,
  loadingState,
  use,
  showDescription = true
}) => {
  const {
    status
  } = useAssetStatus({
    id: Number(trackId),
    type: 'TRACK'
  });
  const inProgress = status === FILTER_CONSTS.STATUSES.IN_PROGRESS;
  const isStarted = status !== FILTER_CONSTS.STATUSES.NOT_STARTED;
  const filterParams = useFilterParams();
  const location = useLocation();
  const [languages, __] = useSearchParamInput(FILTER_TYPES.LANGUAGE, false);
  const language = forceLanguage || languages.length ? languages[0] : undefined;
  const {
    track
  } = useTrack(trackId, language);
  const hasInfoButton = enviro.isQa() ? ['11979', '220'].includes(trackId.toString()) : ['5', '12', '97'].includes(trackId.toString());
  const onClickHandler = useCallback(() => {
    if (!track) return;
    const {
      name,
      certification
    } = track;
    UsageTracker.track('interaction', {
      action: 'content-card-click',
      contentType: 'TRACK',
      trackId,
      appearsIn,
      position,
      name,
      filters: JSON.stringify(filterParams),
      style: 'default',
      isInProgress: inProgress,
      isCertification: !!certification
    });
    if (onClick) onClick(trackId);
  }, [appearsIn, filterParams, inProgress, onClick, position, track, trackId]);
  const to = useMemo(() => {
    if (!track) return null;
    const {
      id
    } = track;
    const {
      pathname,
      search
    } = location;
    const url = getListingUrl({
      type: 'TRACK',
      isStarted: preferPreviewModal !== undefined ? !preferPreviewModal : isStarted,
      id,
      language,
      currentPathname: pathname,
      currentSearch: search,
      appearsIn
    });
    return {
      pathname: url.pathname,
      search: url.search,
      state: {
        backLocation: location
      }
    };
  }, [appearsIn, isStarted, language, location, preferPreviewModal, track]);
  if (!track) return loadingState ? /*#__PURE__*/_jsx(_Fragment, {
    children: loadingState
  }) : null;
  const {
    certification,
    deprecated,
    deprecationCta,
    deprecationMessage,
    description,
    name
  } = track;
  return /*#__PURE__*/_jsx(ContentCard, {
    "data-test-is-certification": !!certification,
    "data-test-is-unfilterable": !!isUnfilterable,
    "data-test-meta": trackId,
    "data-test-type": "track",
    deprecated: deprecated,
    deprecationMessage: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(TrackDeprecatedDescription, {
        cta: deprecationCta,
        message: deprecationMessage,
        trackId: `${trackId}`
      })
    }),
    description: showDescription ? description : undefined,
    footer: footer,
    isFlushOnMobile: isFlushOnMobile,
    isGhost: isGhost,
    name: name,
    onClick: onClickHandler,
    thumbnailOverlayed: /*#__PURE__*/_jsx(TrackThumbnailOverlayed, {
      headerIcons: thumbnailHeaderIcons,
      isGhost: isGhost,
      language: language,
      trackId: trackId
    }),
    title: hasInfoButton && /*#__PURE__*/_jsx(TrackCategoryInfoButton, {
      trackId: trackId
    }),
    to: to,
    use: use
  });
};
export default TrackCardContainer;